<template>
  <div>
    <div class="banner_box">
      <joinpartbanner></joinpartbanner>
    </div>
    <div class="detail_box">
      <div class="join_detail">
        <div class="join_title">
          {{$t("join.engineer")}}
        </div>
        <div class="company_name">
          {{$t("join.companyname")}}
        </div>
        <div class="work_property">
          <span class="work_property1">{{$t("join.worknature")}}<span class="work_property2">{{$t("join.fulltime")}}</span></span>
          <span class="work_property1">{{$t("join.salary")}}<span class="work_property2">{{$t("join.engineermoney")}}</span></span>
          <span class="work_property1">{{$t("join.education")}}<span class="work_property2">{{$t("join.specialist")}}</span></span>
          <span class="work_property1">{{$t("join.workyears")}}<span class="work_property2">{{$t("join.unlimited")}}</span></span>
        </div>
        <div class="job_content">
          <div class="job_describe">
            <div class="job_describe_title">
              {{$t("join.positiondescribe")}}
            </div>
            <div class="job_describe_ul">
              <ul>
                <li>
                  <p>熟悉C/C++开发语言，精通Windows下程序开发</p>
                </li>
                <li>
                  <p>根据项目计划，保质保量按时完成开发任务</p>
                </li>
                <li>
                  <p>编写模块核心代码，解决部品开发中的问题</p>
                </li>
                <li>
                  <p>负责相关产品模块的功能设计，负责产品文档的撰写</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="job_describe">
            <div class="job_describe_title">
              {{$t("join.positionclaim")}}
            </div>
            <div class="job_describe_ul">
              <ul>
                <li>
                  <p>熟悉C++程序设计与开发，熟悉面向对象的思想和设计模式</p>
                </li>
                <li>
                  <p>对算法、数据结构有深入理解</p>
                </li>
                <li>
                  <p>具有软件过程文档设计和编写的能力，能自行编制软件技术、产品服务、市场销售支持等方面的文档</p>
                </li>
                <li>
                  <p>有较强的学习能力和解决问题的能力</p>
                </li>
                <li>
                  <p>具有责任感，良好的解决问题能力和沟通协调能力，富有激情，思维活跃，勇于创新和接受挑战</p>
                </li>
                <li>
                  <p>有实际工作经验者优先</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="job_location">
          {{$t('join.location')}}
        </div>
        <div class="job_return" align="center">
          <div @mouseenter="enter" @mouseleave="leave" :class="isflag==true?'job_return_div1':'job_return_div'"><a
              @click="setroters('/join/index')">返回列表</a></div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import joinpartbanner from "@/components/contentcoms/joincontentcoms/joinpartbanner";
  export default {
    name: "intern",
    components: {
      joinpartbanner
    },
    data() {
      return {
        isflag: false
      }
    },
    methods: {
      setroters(src) {
        this.$router.push(src);
      },
      enter: function () {
        this.isflag = true;
      },
      leave: function () {
        this.isflag = false;
      }
    }
  }

</script>

<style scoped>
  .detail_box {
    margin: 0 auto;
    width: 1200px;
    padding-top: 50px;
  }

  .join_title {
    font-size: 24px;
    color: #333333;
    padding-bottom: 20px;
  }

  .company_name {
    font-size: 14px;
    color: #B6B6B6;
    text-align: left;
    padding-bottom: 16px;
    border-bottom: 1px solid #FBFBFB;
  }

  .work_property {
    padding: 22px 0px 22px 20px;
    text-align: left;
    border-bottom: 1px solid #FBFBFB;
  }

  .work_property1 {
    font-size: 16px;
    color: #666666;
    padding-right: 110px;
  }

  .work_property2 {
    font-size: 16px;
    color: #333333;
  }

  .job_content {
    padding-bottom: 30px;
    border-bottom: 1px solid #FBFBFB;
  }

  .job_describe {
    text-align: left;
    padding: 30px 0px 30px 20px;
  }

  .job_describe_ul {
    padding-top: 18px;
  }

  .job_describe_ul ul {
    color: #2E79BE;
  }

  .job_describe_ul p {
    font-size: 16px;
    color: #666666;
  }

  .job_location {
    text-align: left;
    font-size: 16px;
    color: #333333;
    padding: 20px 0px 20px 20px;
    border-bottom: 1px solid #FBFBFB;
  }
  .job_return {
    margin-top: 10px;
  }
  .job_return a {
    font-size: 14px;

  }

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/joincontentcoms/engineer.vue